export const headerMyDataImmo = {
    title: 'Mes matériels',
    submodules: [
    ],
}

function createData(id, moduleName, ref) {
    return { id, moduleName, ref };
}